import { ENV } from '../Environment'

export const API_ROUTES = {
  baseUrl: ENV().BaseUrl,
  leadsUrl: ENV().LeadsUrl,
  leadsInfo: {
    bsSolution: 'DynamicForms',
    bsWebMethod: 'store-simulation-info-to-lead',
    bsWebService: 'ageas-pt-api-storeSimulationInformation-outsystems-frontend-entry',
  },
  fillDataForSimulation:
    'ageas-pt-petis-ageasonmais-ca-filldataforsimulation-v1/fill-data-for-simulation',
  getEntitiesDetails:
    'ageas-pt-petis-ageasonmais-ca-getentitiesdetails-v1/get-entities-details',
  getAdditionalEntityDetails:
    'ageas-pt-petis-ageasonmais-ca-getadditionalentitydetails-v1/get-additional-entity-details',
  runPetisSimulation:
    'ageas-pt-petis-ageasonmais-ca-runpetissimulation-v1/run-petis-simulation',
  policyholderDetails:
    'ageas-pt-petis-ageasonmais-ca-getpolicyholderdetails-v1/get-policyholder-details',
  validateEntity:
    'ageas-pt-petis-ageasonmais-ca-getpolicyholderdetails-v1/validate-entity',
  validateZipCode:
    'ageas-pt-petis-ageasonmais-ca-validatezipcode-v1/validate-zip-code',
  getEntityDetailsForSummaryDocument:
    'ageas-pt-petis-ageasonmais-ca-getentitydetailsforsummarydocument-v1/get-entity-details-for-summary-document',
  getAdditionalEntityDetailsForSummaryDocument:
    'ageas-pt-petis-ageasonmais-ca-getadditionalentitydetailsforsummarydocument-v1/get-additional-entity-details',
  submitPetsInfo:
    'ageas-pt-petis-ageasonmais-ca-submitpetsinfo-v1/submit-pets-info',
  simulationSummaryDownload:
    'ageas-pt-petis-ageasonmais-ca-simulationsummarydownload-v1/simulation-summary-download',
  submitProposal:
    'ageas-pt-petis-ageasonmais-ca-submitproposal-v1/submit-proposal',
  acceptConditions:
    'ageas-pt-petis-ageasonmais-ca-acceptconditions-v1/accept-conditions',
  createProposal:
    'ageas-pt-petis-ageasonmais-ca-createproposal-v1/create-proposal',
  sendDigitalSignature:
    'ageas-pt-petis-ageasonmais-ca-senddigitalsignaturerequest-v1/send-digital-signature-request',
  downloadDocument:
    'ageas-pt-petis-ageasonmais-ca-downloaddocuments-v1/download-documents',
  createPolicyholderEntity:
    'ageas-pt-petis-ageasonmais-ca-createpolicyholderentity-v1/create-policyholder-entity',
  updateEntityDetails:
    'ageas-pt-petis-ageasonmais-ca-updateentitydetails-v1/update-entity-details',
  refreshDigitalSignatureStatus:
    'ageas-pt-petis-ageasonmais-ca-refreshdigitalsignaturestatus-v1/refresh-digital-signature-status',
  loadPolicyHolderReferenceData:
    'ageas-pt-petis-ageasonmais-ca-loadpolicyholderreferencedata-v1/load-policy-holder-reference-data',
  generateProposalDocuments:
    'ageas-pt-petis-ageasonmais-ca-generateproposaldocuments-v1/generate-proposal-documents',
  recalculatePremium:
    'ageas-pt-petis-ageasonmais-ca-recalculatepremium-v1/recalculate-premium',
  getDigitalSignatureSettings:
    'ageas-pt-petis-sales-ca-getdigitalsignaturesettings-v1/get-digital-signature-settings',
  requestQuotation:
    'ageas-pt-petis-ageasonmais-ca-requestquotation-v1/request-quotation',
  getQuotation: 'ageas-pt-petis-ageasonmais-ca-getquotation-v1/get-quotation',
  updateQuotation:
    'ageas-pt-petis-ageasonmais-ca-updatequotation-v1/update-quotation',
  payment: {
    service: 'ageas-pt-petis-ageasonmais-ca-payfirstreceipt-v1',
    get: '/get-payment-methods',
    put: '/payment',
    share: '/share-payments-reference',
  },
  refreshFirstReceiptStatus:
    'ageas-pt-petis-ageasonmais-ca-refreshfirstreceiptstatus-v1/refresh-first-receipt-status',
  signWithDigitalDevice:
    'ageas-pt-petis-ageasonmais-ca-signwithdigitaldevice-v1/sign-with-digital-device',
  submitPolicyHolderData:
    'ageas-pt-petis-ageasonmais-ca-submitpolicyholderdata-v1/submit-policyholder-data',
  sendDocumentsByEmail:
    'ageas-pt-petis-sales-ca-senddocumentsbyemail-v1/send-documents',
  useResumePetisSimulationProposal:
    'ageas-pt-petis-ageasonmais-ca-resumepetissimulationproposal-v1/resume-petis-simulation-proposal',
  sendPolicyDocumentsByEmail:
    'ageas-pt-petis-ageasonmais-ca-sendpolicydocumentsbyemail-v1/send-policy-documents-by-email',
  resendDigitalSignature:
    'ageas-pt-petis-ageasonmais-ca-resenddigitalsignaturerequest-v1/resend-digital-signature-request',
  establishEntityIbans:
    'ageas-pt-petis-ageasonmais-ca-establishentityibans-v1/establish-entity-ibans',
  uploadDocument:
    'ageas-pt-petis-ageasonmais-ca-uploaddocument-v1/upload-document',
  cancelDigitalSignatureProcess:
    'ageas-pt-petis-ageasonmais-ca-canceldigitalsignatureprocess-v1/cancel-digital-signature-process',
  changeDigitalSignatureProcess:
    'ageas-pt-petis-ageasonmais-ca-changedigitalsignatureprocess-v1/change-digital-signature-process',
} as const
